import { atomWithReset } from "jotai/utils";

export const editImageModalAtom = atomWithReset<{
  visible: boolean;
  originalPictureFile: File | null;
  editedPictureFile: File | null;
}>({
  visible: false,
  originalPictureFile: null,
  editedPictureFile: null
});
